'use client';
import AppLayout from '@/components/AppLayout';
import BlogsContent from './components/BlogsContent';
export default function BlogsPage() {
  return (
    <AppLayout>
      <BlogsContent />
    </AppLayout>
  );
}
